import { createRouter, createWebHistory } from "vue-router";

const adminRoutes = [
  {
    name: "LogList",
    path: "log/list",
    component: () => import("@/views/console/log/LogList.vue"),
  },
  {
    name: "LogViewId",
    path: "log/view/:id",
    component: () => import("@/views/console/log/LogViewId.vue"),
  },
  {
    name: "ErrorList",
    path: "error/list",
    component: () => import("@/views/console/error/ErrorList.vue"),
  },
  {
    name: "ErrorViewId",
    path: "error/view/:id",
    component: () => import("@/views/console/error/ErrorViewId.vue"),
  },
  {
    name: "ServiceView",
    path: "service/list",
    component: () => import("@/views/console/service/ServiceView.vue"),
  },
];

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
    redirect: "/console/log/list",
  },
  {
    path: "/console",
    name: "AdminView",
    component: () => import("@/views/console/AdminView.vue"),
    children: adminRoutes,
    redirect: "/console/log/list",
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
